import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../../components/button';
import H1 from '../../components/h1';
import Spacer from '../../components/spacer';
import P from '../../components/p';
import BackButton from '../../components/backButton';

function AddAccountPre() {
  const { t } = useTranslation('onboarding');
  const history = useHistory();
  return (

    <div className="container mx-auto">
      <div className="flex flex-col justify-center items-center text-white p-4 text-center min-h-screen-minus-footer">

        <H1>{t('onboarding:add-new-account-header')}</H1>
        <Spacer />
        <P>{t('onboarding:add-new-account-text1')}</P>
        <Spacer slim />
        <P>
          {t('onboarding:add-new-account-text2')}
          {' '}
          <a className="underline" href="mailto:support@sentricmusic.com">support@sentricmusic.com</a>
          .
        </P>
        <Spacer />
        <div className="flex flex-row">

          <BackButton onClick={() => history.goBack()}>{t('onboarding:back-button')}</BackButton>
          <Button onClick={() => history.push('/add-account-1')}>{t('onboarding:next-step-button')}</Button>
        </div>
      </div>
    </div>
  );
}

export default AddAccountPre;
